import React from "react";
import { useSelector } from "react-redux";
import VisibilitySensor from "react-visibility-sensor";
import {
  getRightContent,
  getVisibleSensorAnimation,
  numberWithCommas,
  setAdditionalClasses,
} from "../../assets/js/utils";
import TabSelector from "../TabSelector";
import content from "../../assets/content/content.json";
import PencilShape from "../PencilShape";
import { bulletImages, pencilShapeImages } from "../../assets/js/images";
import constants from "../../assets/js/constants";
import tableListDescriptorImage2 from "../../assets/images/account-opened.png";
import tableListDescriptorImage3 from "../../assets/images/connected.png";
import doubleSweeperImage2 from "../../assets/images/training-seat.png";

import plamImage from "../../assets/images/palm.png";
import borderSecondaryImage from "../../assets/images/border-secondary.png";
import borderSecondaryThinImage from "../../assets/images/thin-border-secondary.png";
import HorizontalBroomSweeper from "../HorizontalBroomSweeper";
import TableListDescriptor from "../TableListDescriptor";
import PieChartContainer from "../PieChartContainer";
import pieChartImage from "../../assets/images/pie-chart.png";
import branchImage from "../../assets/images/bank.png";
import InfoDescriptor from "../InfoDescriptor";
import Counter from "../Counter";
import DoubleBroomSweeper from "../DoubleBroomSweeper";
import CustomReadMore from "../CustomReadMore";
import TableDescriptor from "../TableDescriptor";
import TapeLabel from "../TapeLabel";
import MediaItem from "../MediaItem";

import digitalAccountIcon from "../../assets/images/digital-account.svg";
import ColorfullTable from "../ColorfullTable";
import useWindowSize from "../hooks/useWindowSize";
import CircleMedia from "../CircleMedia";
import MapImage from "../../assets/images/map.png";

const mediaItemIcons = [digitalAccountIcon, null];

function Section4(props) {
  const sections = useSelector((state) => state.ui.sections);
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  const windowWidth = useWindowSize();
  return (
    <div>
      <TabSelector
        tabs={getRightContent(
          generalSettings.rtlLanguage,
          content.sections[sections.currentSection].content.tabSelector.label
        )}
        contents={[
          <>
            <VisibilitySensor partialVisibility>
              {({ isVisible }) => (
                <div style={getVisibleSensorAnimation(isVisible, "fadeIn 1s")}>
                  <div className="center-wrapper-just-wide-screen">
                    <h1
                      className="section4-header general-m"
                      style={{ borderBottom: 0 }}
                    >
                      {
                        getRightContent(
                          generalSettings.rtlLanguage,
                          content.sections[sections.currentSection].content
                            .tabSelector.label
                        )[0]
                      }
                    </h1>
                  </div>
                  <div className="general-m-just-wide-screen">
                    <p
                      className="section4__sub-title general-m-just-small-screen"
                      // style={{
                      //   color: constants.COLORS.PRIMARY,
                      //   marginBottom: "40px",
                      // }}
                    >
                      {
                        getRightContent(
                          generalSettings.rtlLanguage,
                          content.sections[sections.currentSection].content
                            .subTitle
                        )[0]
                      }
                    </p>
                  </div>
                </div>
              )}
            </VisibilitySensor>
            {content.sections[sections.currentSection].content.pencilShapes.map(
              (pencilShape, index) => (
                <VisibilitySensor partialVisibility key={index}>
                  {({ isVisible }) => (
                    <div
                      style={getVisibleSensorAnimation(isVisible, "fadeIn 1s")}
                    >
                      <PencilShape
                        applyOpacity={pencilShape.applyOpacity}
                        backgroundColor={pencilShape.backgroundColor}
                        bottomShape={pencilShape.bottomShape}
                        topShape={pencilShape.topShape}
                        images={index === 1 ? pencilShapeImages : []}
                        title={getRightContent(
                          generalSettings.rtlLanguage,
                          pencilShape.title
                        )}
                        titleColor={pencilShape.titleColor}
                        items={pencilShape.items}
                      />
                    </div>
                  )}
                </VisibilitySensor>
              )
            )}
            {/* <div className="general-2lp-just-wide-screen general-m-just-small-screen mt-40-70">
              {getRightContent(
                generalSettings.rtlLanguage,
                content.sections[sections.currentSection].content.textSequence1
              ).map((textSeq, index) => (
                <VisibilitySensor partialVisibility key={index}>
                  {({ isVisible }) => (
                    <p
                      style={getVisibleSensorAnimation(
                        isVisible,
                        `fadeIn 1s ${index * 0.1}s backwards`
                      )}
                    >
                      {textSeq}
                    </p>
                  )}
                </VisibilitySensor>
              ))}
            </div> */}

            <div className="general-2lp-just-wide-screen general-m-just-small-screen mt-40-70">
              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.titleH2FirstAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore1.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore1.complement
                )}
              />

              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.titleH2SecondAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore2.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore2.complement
                )}
              />
              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.titleH2ThirdAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore3.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore3.complement
                )}
              />

              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.titleH2FourthAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore4.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore4.complement
                )}
              />

              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.titleH2FifthAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore5.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore5.complement
                )}
              />

              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.titleH2SixthAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore6.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore6.complement
                )}
              />

              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.titleH2SeventhAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore7.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore7.complement
                )}
              />

              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.titleH2EighthAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore8.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .ourStrategyReadMore.customReadMore8.complement
                )}
              />
            </div>
            <div className="mt-40-70">
              <VisibilitySensor partialVisibility>
                {({ isVisible }) => (
                  <div className="max-width-55 right-align">
                    <HorizontalBroomSweeper
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content
                          .horizontalSweeper1.text
                      )}
                      borderImage={borderSecondaryImage}
                      centralImage={plamImage}
                      thinBorderImage={borderSecondaryThinImage}
                    />
                  </div>
                )}
              </VisibilitySensor>
            </div>
          </>,
          <>
            <VisibilitySensor partialVisibility>
              {({ isVisible }) => (
                <div style={getVisibleSensorAnimation(isVisible, "fadeIn 1s")}>
                  <div className="center-wrapper-just-wide-screen">
                    <h1
                      className="section4-header general-m"
                      style={{ borderBottom: 0 }}
                    >
                      {
                        getRightContent(
                          generalSettings.rtlLanguage,
                          content.sections[sections.currentSection].content
                            .tabSelector.label
                        )[1]
                      }
                    </h1>
                  </div>
                  <div className="general-m-just-wide-screen">
                    <p
                      className="section4__sub-title general-m-just-small-screen"
                      // style={{
                      //   color: constants.COLORS.PRIMARY,
                      //   margin: "40px auto",
                      //   textAlign: "center",
                      // }}
                    >
                      {
                        getRightContent(
                          generalSettings.rtlLanguage,
                          content.sections[sections.currentSection].content
                            .subTitle
                        )[1]
                      }
                    </p>
                  </div>
                </div>
              )}
            </VisibilitySensor>
            {/* <VisibilitySensor partialVisibility>
              {({ isVisible }) => (
                <div className="section4__first-container">
                  <TableListDescriptor
                    items={[
                      <PieChartContainer
                        image={pieChartImage}
                        title={
                          getRightContent(
                            generalSettings.rtlLanguage,
                            content.sections[sections.currentSection].content
                              .tableListDescriptor.title
                          )[0]
                        }
                        partsDescriptor={getRightContent(
                          generalSettings.rtlLanguage,
                          content.sections[sections.currentSection].content
                            .tableListDescriptor.partDescriptor
                        )}
                        bulletImages={bulletImages}
                      />,
                      <div className="flex-line"></div>,
                      <PieChartContainer
                        iconImage={true}
                        image={tableListDescriptorImage2}
                        title={
                          getRightContent(
                            generalSettings.rtlLanguage,
                            content.sections[sections.currentSection].content
                              .tableListDescriptor.title
                          )[1]
                        }
                        Component={
                          <InfoDescriptor
                            topUnit={
                              getRightContent(
                                generalSettings.rtlLanguage,
                                content.sections[sections.currentSection]
                                  .content.tableListDescriptor.infoDescriptor
                                  .topUnit
                              )[0]
                            }
                            value={numberWithCommas(
                              content.sections[sections.currentSection].content
                                .tableListDescriptor.infoDescriptor.value[0]
                            )}
                          />
                        }
                      />,
                      <div className="flex-line"></div>,
                      <PieChartContainer
                        iconImage={true}
                        image={tableListDescriptorImage3}
                        title={
                          getRightContent(
                            generalSettings.rtlLanguage,
                            content.sections[sections.currentSection].content
                              .tableListDescriptor.title
                          )[2]
                        }
                        Component={
                          <InfoDescriptor
                            topUnit={
                              getRightContent(
                                generalSettings.rtlLanguage,
                                content.sections[sections.currentSection]
                                  .content.tableListDescriptor.infoDescriptor
                                  .topUnit
                              )[1]
                            }
                            value={numberWithCommas(
                              content.sections[sections.currentSection].content
                                .tableListDescriptor.infoDescriptor.value[1]
                            )}
                          />
                        }
                      />,
                    ]}
                  />
                  <VisibilitySensor partialVisibility>
                    {({ isVisible }) => (
                      <div
                        className="section4__branch-container"
                        style={getVisibleSensorAnimation(
                          isVisible,
                          `fadeIn 1s 0.5s backwards`
                        )}
                      >
                        <img
                          src={branchImage}
                          alt=""
                          className="branch-container__image"
                        />
                        <p className="branch-container__text">
                          {getRightContent(
                            generalSettings.rtlLanguage,
                            content.sections[sections.currentSection].content
                              .branchContainer.text
                          )}
                        </p>
                        <Counter
                          value={
                            content.sections[sections.currentSection].content
                              .branchContainer.value
                          }
                        />
                        <span className="branch-container__label">
                          {getRightContent(
                            generalSettings.rtlLanguage,
                            content.sections[sections.currentSection].content
                              .branchContainer.label
                          )}
                        </span>
                      </div>
                    )}
                  </VisibilitySensor>
                </div>
              )}
            </VisibilitySensor> */}
            {/* <p className="section4__bold-paragraph general-m-just-small-screen">
              {getRightContent(
                generalSettings.rtlLanguage,
                content.sections[sections.currentSection].content.boldParagraph
              )}
            </p> */}

            {/* New Content Changed */}

            <div className="section4__op-review-image-container">
              <VisibilitySensor partialVisibility>
                {({ isVisible }) => (
                  <picture>
                    <source
                      media="(max-width: 500px)"
                      srcSet={require("../../assets/images/operating-review.jpg")}
                    />
                    <source
                      media="(min-width: 501px)"
                      srcSet={require("../../assets/images/operating-review@2x.jpg")}
                    />
                    <img
                      src={require("../../assets/images/operating-review.jpg")}
                      alt=""
                      className="op-review-image"
                      style={getVisibleSensorAnimation(
                        isVisible,
                        `fadeIn 1s backwards`
                      )}
                    />
                  </picture>
                )}
              </VisibilitySensor>

              <VisibilitySensor partialVisibility>
                {({ isVisible }) => (
                  <p
                    className="op-review-image_label"
                    style={getVisibleSensorAnimation(
                      isVisible,
                      `fadeInReverse 1s backwards`
                    )}
                  >
                    {getRightContent(
                      generalSettings.rtlLanguage,
                      content.sections[sections.currentSection].content
                        .operatingReviewImageDescription
                    )}
                  </p>
                )}
              </VisibilitySensor>
            </div>

            <div className="general-2lp-just-wide-screen general-m-just-small-screen">
              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .titleH2FirstAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .customReadMore1.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .customReadMore1.complement
                )}
              />
            </div>

            <div className="separate-components edge-tab-selector">
              <TapeLabel
                components={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.mediaItems
                ).map((mediaItem, index) => (
                  <MediaItem
                    key={index}
                    bottomText={mediaItem.bottomText}
                    value={mediaItem.value}
                    icon={mediaItemIcons[index]}
                    upperIcon={true}
                  />
                ))}
              />
            </div>

            <VisibilitySensor partialVisibility>
              {({ isVisible }) =>
                getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .subTitleFirstAppeareance
                ).map((subTitle, index) => (
                  <h2
                    className="mb-0  mt-0 section4_inside-subtitle general-m-just-small-screen"
                    key={index}
                    style={getVisibleSensorAnimation(
                      isVisible,
                      `fadeIn 1s backwards`
                    )}
                  >
                    {subTitle}
                  </h2>
                ))
              }
            </VisibilitySensor>

            <div className="section4__colorfull-table-container general-m-just-small-screen">
              <div className="colorfull-table-1">
                <VisibilitySensor partialVisibility>
                  {({ isVisible }) => (
                    <>
                      <div
                        className="line-4 mb-20"
                        style={getVisibleSensorAnimation(
                          isVisible,
                          `${
                            windowWidth > 767 ? "width-increase" : "fadeIn"
                          } 1.2s backwards`
                        )}
                      ></div>
                      <h3
                        className="subtitle"
                        style={getVisibleSensorAnimation(
                          isVisible,
                          `fadeInReverse 1s backwards`
                        )}
                      >
                        {getRightContent(
                          generalSettings.rtlLanguage,
                          content.sections[sections.currentSection].content
                            .colorFullTableNetwork1
                        )}
                      </h3>
                    </>
                  )}
                </VisibilitySensor>
                <ColorfullTable
                  rows={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .colorFullTable1
                  )}
                />
              </div>
              <div className="colorfull-table-2">
                <VisibilitySensor partialVisibility>
                  {({ isVisible }) => (
                    <>
                      <div
                        className="line-4 secondary mb-20"
                        style={getVisibleSensorAnimation(
                          isVisible,
                          `${
                            windowWidth > 767
                              ? "width-increase-flipped"
                              : "fadeIn"
                          } 1.2s backwards`
                        )}
                      ></div>
                      <h3
                        className={`subtitle ${setAdditionalClasses(
                          ["right-text"],
                          [windowWidth > 767]
                        )}`}
                        style={getVisibleSensorAnimation(
                          isVisible,
                          `fadeInReverse 1s backwards`
                        )}
                      >
                        {getRightContent(
                          generalSettings.rtlLanguage,
                          content.sections[sections.currentSection].content
                            .colorFullTableNetwork2
                        )}
                      </h3>
                    </>
                  )}
                </VisibilitySensor>
                <ColorfullTable
                  rows={getRightContent(
                    generalSettings.rtlLanguage,
                    content.sections[sections.currentSection].content
                      .colorFullTable2
                  )}
                  colorHeader={constants.COLORS.SECONDARY}
                />
              </div>
            </div>

            <div className="section4__map-container general-m-just-small-screen">
              <VisibilitySensor partialVisibility>
                {({ isVisible }) => (
                  <img
                    src={MapImage}
                    alt=""
                    className="map-image"
                    style={getVisibleSensorAnimation(
                      isVisible,
                      `fadeIn 1s  backwards `
                    )}
                  />
                )}
              </VisibilitySensor>
              <div className="flex-col map-image__descriptor">
                <VisibilitySensor partialVisibility>
                  {({ isVisible }) => (
                    <p
                      style={getVisibleSensorAnimation(
                        isVisible,
                        `fadeInReverse 1s backwards `
                      )}
                      className="map-image__descriptor-text"
                    >
                      {getRightContent(
                        generalSettings.rtlLanguage,
                        content.sections[sections.currentSection].content.map
                          .text
                      )}
                    </p>
                  )}
                </VisibilitySensor>

                <VisibilitySensor partialVisibility>
                  {({ isVisible }) => (
                    <div className="flex-row wrap right-align">
                      <div
                        style={getVisibleSensorAnimation(
                          isVisible,
                          `bounce-inter-2 0.5s 0.5s backwards `
                        )}
                      >
                        <CircleMedia
                          value={
                            content.sections[sections.currentSection].content
                              .map.branches.value
                          }
                          description={getRightContent(
                            generalSettings.rtlLanguage,
                            content.sections[sections.currentSection].content
                              .map.branches.text
                          )}
                        />
                      </div>
                      <div
                        style={getVisibleSensorAnimation(
                          isVisible,
                          `bounce-inter-2 0.5s 1s backwards `
                        )}
                      >
                        <CircleMedia
                          value={
                            content.sections[sections.currentSection].content
                              .map.enjaz.value
                          }
                          description={getRightContent(
                            generalSettings.rtlLanguage,
                            content.sections[sections.currentSection].content
                              .map.enjaz.text
                          )}
                          backgroundColor={constants.COLORS.SECONDARY}
                        />
                      </div>
                    </div>
                  )}
                </VisibilitySensor>
              </div>
            </div>

            <div className="general-m-just-small-screen section4__sweeper">
              <DoubleBroomSweeper
                firstComponent={
                  <PieChartContainer
                    iconImage={true}
                    image={doubleSweeperImage2}
                    title={""}
                    Component={
                      <p className="double-broom-sweeper__text">
                        {getRightContent(
                          generalSettings.rtlLanguage,
                          content.sections[sections.currentSection].content
                            .doubleSweeper1Firstpart.text
                        )}
                      </p>
                    }
                  />
                }
                // secondComponent={
                //   <PieChartContainer
                //     iconImage={true}
                //     image={tableListDescriptorImage2}
                //     title={
                //       getRightContent(
                //         generalSettings.rtlLanguage,
                //         content.sections[sections.currentSection].content
                //           .tableListDescriptor.title
                //       )[2]
                //     }
                //     Component={
                //       <InfoDescriptor
                //         topUnit={
                //           getRightContent(
                //             generalSettings.rtlLanguage,
                //             content.sections[sections.currentSection].content
                //               .tableListDescriptor.infoDescriptor.topUnit
                //           )[1]
                //         }
                //         value={numberWithCommas(
                //           content.sections[sections.currentSection].content
                //             .tableListDescriptor.infoDescriptor.value[1]
                //         )}
                //       />
                //     }
                //   />
                // }
              />
            </div>

            <div className="general-2lp-just-wide-screen general-m-just-small-screen mt-40-70">
              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .titleH2FirstAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore1.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore1.complement
                )}
              />

              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .titleH2SecondAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore2.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore2.complement
                )}
              />

              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .titleH2ThirdAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore3.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore3.complement
                )}
              />

              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .titleH2FourthAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore4.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore4.complement
                )}
              />

              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .titleH2FifthAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore5.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore5.complement
                )}
              />

              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .titleH2SixthAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore6.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore6.complement
                )}
              />

              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .titleH2SeventhAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore7.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore7.complement
                )}
              />

              <h2 className="content-sub-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .titleH2EighthAppeareance
                )}
              </h2>
              <CustomReadMore
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore8.text
                )}
                textComplement={getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.cReadMore
                    .customReadMore8.complement
                )}
              />
            </div>

            {/* New Content Changed */}

            {/* {getRightContent(
              generalSettings.rtlLanguage,
              content.sections[sections.currentSection].content.textSequence2
            ).map((textSeq, index) => (
              <VisibilitySensor partialVisibility key={index}>
                {({ isVisible }) => (
                  <div className="flexible-items__container max-width-60">
                    <p
                      style={getVisibleSensorAnimation(isVisible, "fadeIn 1s")}
                    >
                      {textSeq}
                    </p>
                  </div>
                )}
              </VisibilitySensor>
            ))}
            <div className="flexible-items__container max-width-60 left-alignment">
              <h2 className="section4__text-sequence-title">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content
                    .textSequence3Title
                )}
              </h2>
            </div>
            {getRightContent(
              generalSettings.rtlLanguage,
              content.sections[sections.currentSection].content.textSequence3
            ).map((textSeq, index) => (
              <VisibilitySensor partialVisibility key={index}>
                {({ isVisible }) => (
                  <div
                    className={`flexible-items__container max-width-60${setAdditionalClasses(
                      ["mt-0"],
                      [index === 0]
                    )}`}
                  >
                    <p
                      style={getVisibleSensorAnimation(isVisible, "fadeIn 1s")}
                    >
                      {textSeq}
                    </p>
                  </div>
                )}
              </VisibilitySensor>
            ))} */}
          </>,
        ]}
      />
    </div>
  );
}

export default Section4;
